/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_In_Reason_Return_From_SortingInputs */

const vi_pl_in_reason_return_from_sorting = /** @type {(inputs: Pl_In_Reason_Return_From_SortingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoàn từ phân loại`)
};

/**

* @param {Pl_In_Reason_Return_From_SortingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_in_reason_return_from_sorting = /** @type {((inputs?: Pl_In_Reason_Return_From_SortingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_In_Reason_Return_From_SortingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_in_reason_return_from_sorting(inputs)
});